import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';

const Layout = styled.div`
  width: ${(props) => (props.navOpen ? 'calc(100% - 380px)' : '100%')};
  .no-layout {
    background-image: url(${`${envConfig.imageRoot}svg/EmptyReport.svg`});
    background-repeat: no-repeat;
    background-size: 20%;
    background-position: center;
  }
`;
const BuilderWrapper = styled.div`
  .Polaris-Connected__Item {
    flex: 0 0 auto !important;
  }
  .rule-fields {
    width: 95% !important;
    max-width: 98% !important;
  }

  min-width: 1150px;
  height: ${(props) => (props.isExport ? '100%' : 'calc(100vh - 165px)')};
  .react-grid-layout {
    width: 100%;
    min-height: 100%;
  }
  .header-tag {
    margin-bottom: 0 !important;
  }
  .react-grid-item .value_selector__control {
    background: #fff;
  }
  .chart-title {
    font-size: 20px;
    line-height: 1.5;
    font-weight: 700;
    cursor: ${(props) => (props.isExport ? 'default' : 'pointer')};
    white-space: normal;
    .title {
      padding: 1px 5px;
    }
  }
  .description {
    padding: 1px 5px;
  }
`;

const El = styled.div`
  .chart-card {
    cursor: ${(props) => (props.isExport ? 'default' : 'grab')};
    border-radius: 10px;
    box-shadow: 0px 1.8266634941101074px 20.093297958374023px 0px #0000000e;
  }
  .chart_grid {
    height: calc(100% - 83px);
  }
  &:hover {
    .gridHeader {
      background: #e2e2e2d1;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      transition: background-color 300ms linear;
    }
  }
  .summaryTable {
    height: calc(100% - 30px) !important;
  }
`;

const EntityBadge = styled.div.attrs({ className: 'flex actr jctr ptr' })`
  width: 33px;
  min-width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: ${(props) => (props.color ? props.color : '#fce2e0')};
  .emoji {
    margin: auto;
  }
`;

export { BuilderWrapper, Layout, El, EntityBadge };
